//@flow

import React from 'react';
import { Label, Button } from 'reactstrap';
import { RadioGroup, Radio } from 'react-radio-group';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';

import { activeClassNameFor } from './helpers';

type Props = {
  trekType: string,
  services: Array<String>,
  interestedRegions: Array<String>,
  dispatch: Function,
  disabled: boolean,
};

const regions = ['Everest', 'Annapurna', 'Manaslu', 'Langtang', 'Others'];

const servicesArr = ['Lodge Booking', 'Flights Booking', 'Porter'];

export default function TravelDetail(props: Props) {
  const { interestedRegions, trekType, dispatch, services, disabled } = props;

  return (
    <div className="travel-detail">
      <div className="travel-question-box">
        <h3 className="onboard-question mb-4 text-center">
          Where would you like to travel?
        </h3>
        <CheckboxGroup
          name="regions"
          value={interestedRegions}
          checkboxDepth={4}
          onChange={value => dispatch({ type: 'CHANGE', interestedRegions: value })}
        >
          <ul className="traveler-type">
            {regions.map(region => (
              <li key={region}>
                <label>
                  <Checkbox value={region} /> <span /> {region}
                </label>
              </li>
            ))}
          </ul>
        </CheckboxGroup>
      </div>

      <div className="travel-question-box">
        <h3 className="onboard-question mb-4 text-center">
          What kind of treks would you like to go on?
        </h3>

        <RadioGroup
          className="travel-dates-options"
          selectedValue={trekType}
          onChange={value => dispatch({ type: 'CHANGE', trekType: value })}
        >
          <ul>
            <RadioButton
              value="independentTrek"
              selectedValue={trekType}
              text="Independent Trek"
            />

            {trekType === 'independentTrek' ? (
              <CheckboxGroup
                name="question"
                value={services}
                checkboxDepth={4}
                onChange={value => dispatch({ type: 'CHANGE', services: value })}
              >
                <ul>
                  {servicesArr.map(service => (
                    <li key={service}>
                      <label>
                        <Checkbox value={service} /> <span /> {service}
                      </label>
                    </li>
                  ))}
                </ul>
              </CheckboxGroup>
            ) : null}

            <RadioButton
              value="privateTreks"
              selectedValue={trekType}
              text="Private Treks"
            />
            <RadioButton value="hireAGuide" selectedValue={trekType} text="Hire A Guide" />
          </ul>
        </RadioGroup>
      </div>

      <div className="col-12 button-center">
        <Button
          color="yellow"
          className="mr-3"
          onClick={() => dispatch({ type: 'DECREMENT', key: 'step' })}
        >
          Back
        </Button>
        {!disabled && (
          <Button
            color="yellow"
            onClick={() => dispatch({ type: 'INCREMENT', key: 'step' })}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  );
}

type RadioButtonProps = {
  value: string,
  selectedValue: string,
  text: string,
};

const RadioButton = ({ value, selectedValue, text }: RadioButtonProps) => (
  <li>
    <Label className={`btn btn-onboard-radio ${activeClassNameFor(selectedValue, value)}`}>
      <Radio value={value} />
      {text}
    </Label>
  </li>
);



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/TravelDetail.jsx